import { RELEASES_TEMPLATE_DOWNLOAD_URL } from 'constants/ApiConstants';
import { getTemplate as getTemplateMedia } from 'modules/medias/actions';
import * as types from 'modules/releases/actionTypes';

/**
 * @param {string} releaseId
 * @param {string} [noteId]
 * @param {Object} [meta={}]
 * @returns {OpenNoteModalAction}
 */
export const openNoteModal = (releaseId, noteId = null, meta = {}) => ({
  type: types.OPEN_NOTE_MODAL,
  payload: { releaseId, noteId },
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {CloseNoteModalAction}
 */
export const closeNoteModal = (meta = {}) => ({
  type: types.CLOSE_NOTE_MODAL,
  meta,
});

/**
 * @param {string} releaseId
 * @param {Object} [meta={}]
 * @returns {OpenNoteCsvModalAction}
 */
export const openNoteCsvModal = (releaseId, meta = {}) => ({
  type: types.OPEN_NOTE_CSV_MODAL,
  payload: { releaseId },
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {CloseNoteModalAction}
 */
export const closeNoteCsvModal = (meta = {}) => ({
  type: types.CLOSE_NOTE_CSV_MODAL,
  meta,
});

export const getTemplate = (params, meta = {}) => getTemplateMedia(
  {
    url: RELEASES_TEMPLATE_DOWNLOAD_URL,
    params
  },
  meta
);
